import { connect } from 'react-redux';

import { StickBottom, IStickBottomProps } from '../../components/StickBottom';
import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { setVisibleStickBottom } from '../../actions/stickBottom';
import { defaultState as defaultStateFeedback } from '../../reducers/feedback';

type TStoreProps = Pick<IStickBottomProps, 'isVisible' | 'feedbackTopPosition' | 'feedbackHeight'>;
type TDispatchProps = Pick<IStickBottomProps, 'setVisibleStickBottom'>;

export function mapStateToProps(state: IApplicationState): TStoreProps {
  const isVisibleForm =
    typeof state.feedback.isVisibleForm === 'boolean'
      ? state.feedback.isVisibleForm
      : (defaultStateFeedback.isVisibleForm as boolean);

  return {
    isVisible: state.stickBottom.isVisible && isVisibleForm,
    feedbackTopPosition: state.feedback.topPosition,
    feedbackHeight: state.feedback.height,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TDispatchProps {
  return {
    setVisibleStickBottom: (visible: boolean) => dispatch(setVisibleStickBottom(visible)),
  };
}

export function mergeProps(storeProps: TStoreProps, dispatchProps: TDispatchProps) {
  const { feedbackTopPosition } = storeProps;

  return {
    ...storeProps,
    ...dispatchProps,
    scrollToFeedback: () =>
      window.scrollTo({
        top: feedbackTopPosition,
        left: 0,
        behavior: 'smooth',
      }),
  };
}

export const StickBottomContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(StickBottom);
